export const SEARCH_ENTITY_TYPE = 'mso.search_action';
export const STRING_ENTITY_TYPE = 'string';

export interface DoradoActionParameter {
    type: string;
    name: string;
    value: string;
    requiresUserInput: boolean;
}

export default DoradoActionParameter;
